import { tokens } from '@welbe/web-design-system';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	.header-icon {
		width: 36px;
		height: 36px;
		& > path {
			fill: ${tokens.color_white};
		}
	}
`;

export const Container = styled.div`
	display: grid;
	grid-template-rows: 70px 1fr 80px;
	min-height: 570px;
	height: 100%;
	gap: 16px;
`;

export const Title = styled.h1`
	color: ${tokens.color_primary};
	margin-top: 10px;
	font-weight: 600;
	font-size: 16px;
	text-align: center;
	margin-bottom: 10px;
`;

export const Description = styled.p`
	font-size: 14px;
	font-weight: 600;
	text-align: center;
	color: ${tokens.color_gray_dark};
`;

export const Content = styled.div<{ loading?: boolean }>`
	display: flex;
	flex-direction: column;
	height: 100%;
	max-height: 380px;
	overflow-y: scroll;

	${({ loading }) =>
		loading &&
		css`
			justify-content: center;
			align-items: center;
		`}

	::-webkit-scrollbar {
		width: 4px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background: #888;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
`;

export const Footer = styled.div<{ justifyEnd?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
	justify-content: ${({ justifyEnd }) =>
		justifyEnd ? 'end' : 'space-between'};
`;
